import {
  createDirectus,
  rest,
  //staticToken,
  // withOptions,
  //refresh,
  readItems,
  readItem,
  authentication,
  // graphql,
  // withToken,
  aggregate,
  updateItem,
  createItem,
  deleteItem,
} from "@directus/sdk";

const client = createDirectus(location.origin) //"https://ds.crm.iotd.ru"
  .with(authentication("cookie"))
  .with(rest());
//.with(authentication("cookie", { credentials: "include" }))
//.with(graphql({ credentials: "include" }))
//.with(rest({ credentials: "include" }))
//   .with(
//     rest({
//       onRequest: (options) => ({ ...options, cache: "no-store" }),
//       credentials: "include",
//     })
//   );

async function getAll() {
  // const token = await client.getToken();
  // console.log("token", token);
  return await client.request(readItems("groups"));
}
async function get(limit, offset, search, sort) {
  let query = {
    limit,
    offset,
    fields: ["*"],
  };
  if (sort) query.sort = sort;
  if (search.length > 0) query.search = search;
  const totalCount = await client.request(
    aggregate("groups", {
      aggregate: { count: "*" },
      query: {},
    })
  );

  const data = await client.request(readItems("groups", query));
  return { totalCount: totalCount[0].count, data };
}
async function getById(id) {
  return await client.request(
    readItem("groups", id, {
      fields: [
        "*,agents.*,agents.agents_id.*,contacts.*,contacts.contacts_id.*",
      ],
    })
  );
}

async function create(data) {
  return await client.request(
    createItem("groups", data, {
      fields: [
        "*,agents.*,agents.agents_id.*,contacts.*,contacts.contacts_id.*",
      ],
    })
  );
}
async function updateById(id, data) {
  return await client.request(
    updateItem("groups", id, data, {
      fields: [
        "*,agents.*,agents.agents_id.*,contacts.*,contacts.contacts_id.*",
      ],
    })
  );
}

async function deleteById(id) {
  return await client.request(deleteItem("groups", id));
}
export default {
  get,
  getAll,
  create,
  deleteById,
  getById,
  updateById,
};
